export default "__VITE_ASSET__GKEBXpnk__"